import { Module } from '../../types'

/* Randomly generate keys and ids for module sections in carousels and other modular components */
export const getModuleIds = (modules: Module[]): Array<string> => {
  return modules?.map(() =>
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .slice(0, 5)
  )
}
